import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-loginAuth',
  template: '<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>',
  standalone: false
})
export class LoginVistaComponent implements OnInit {

  private _user = null;
  msg: string = '';
  constructor() {
  }

  ngOnInit() {

  }

}
